$( document ).ready( function() {
	'use strict';

	$( '.btn-print-event-agenda' ).click( printLetter );

} );

function printLetter() {
	setTimeout( function() {
		w.print();
	}, 100 );

	let w = window.open( $( this ).attr( 'href' ) );

	w.onafterprint = function() {
		w.close();
	};
}